$(document).on('submit', '#diagnosticForm', function(e) { 
    $(this).addClass('loading-form');
    e.preventDefault(); 

    // Získání hodnot z formuláře
    var formName = $(this).find('#jmeno').val();
    var formSurname = $(this).find('#prijmeni').val();
    var formEmail = $(this).find('#email').val();
    var formPhone = $(this).find('#telefon').val();
    var formHeight = $(this).find('#vyska').val();
    var formWeight = $(this).find('#vaha').val();
    var formAge = $(this).find('#vek').val();
    var formMedications = $(this).find('#leky').val();
    var formAllergies = $(this).find('#alergie').val();
    var formProblemDescription = $(this).find('#problem').val();
    var fileInput = $(this).find('#foto_jazyka')[0].files[0];

    // Získání hodnot diagnostického dotazníku
    var diagnosticData = {};
    $(this).find('select').each(function() {
        var fieldName = $(this).attr('name');
        var fieldValue = $(this).val() || $(this).find('option:selected').text(); // Pokud není hodnota, použije text
        diagnosticData[fieldName] = fieldValue;
    });

    // Přidání dat do FormData
    var formdata = new FormData();
    formdata.append("name", formName);
    formdata.append("surname", formSurname);
    formdata.append("email", formEmail);
    formdata.append("phone", formPhone);
    formdata.append("height", formHeight);
    formdata.append("weight", formWeight);
    formdata.append("age", formAge);
    formdata.append("medications", formMedications);
    formdata.append("allergies", formAllergies);
    formdata.append("problem_description", formProblemDescription);
    formdata.append("file", fileInput);

    // Přidání diagnostických dat do FormData
    for (var key in diagnosticData) {
        formdata.append(key, diagnosticData[key]);
    }

    // Nastavení požadavku
    var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    // Odeslání dat na server
    fetch("https://tools.shopcode.cz/e-mail_sender/nestonej/www/", requestOptions)
    .then(response => response.json())
    .then(function(result){
        console.log(result.status);
        showMessage('Formulář byl úspěšně odeslán, budeme vás kontaktovat.', 'success', '', false, true);
        if(result.status === 'ok'){
            $('#diagnosticForm').removeClass('loading-form');
            $('#diagnosticForm')[0].reset();
        }
    })
    .catch(function(){
        showMessage('Při odeslání nastala chyba, zkuste to prosím znovu.', 'error', '', false, true);
        $('#diagnosticForm').removeClass('loading-form');

    });
});